<template>
    <div class="uk-width-large uk-container uk-container-center uk-tile">
        <p class="uk-text-center uk-margin-bottom">退会処理を取り消すことはできません。<br>問題なければ以下より退会処理にお進みください。</p>
        <div class="">
            <button type="submit" @click="submitLeave()" class="uk-width-1-1 uk-button uk-button-danger">{{ button.leave }}</button>
        </div>
    </div>
</template>

<script>
import { getCookieValue } from '../util'
export default {
    data () {
        return {
            button: {
                leave: '退会する',
            }
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth.user
        },
        token () {
            return this.$store.state.auth.token
        },
    },
    methods: {
        async submitLeave() {
            this.button.leave = '...実行中';
            await this.$store.dispatch('auth/leave', {
                api_token: getCookieValue('token'),
            })
        }
    },
    mounted() {
    },
    created () {
    }
}
</script>
